import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Package, TrendingUp, AlertCircle, CheckCircle, Search, Download, RefreshCw, MapPin } from 'lucide-react';
export function WarehouseInventory() {
  const inventory = [{
    id: 'WH-INV-001',
    sku: 'SKU-IM-001',
    name: 'Indomie Goreng Special',
    category: 'Makanan',
    stock: 1200,
    unit: 'Karton',
    location: 'Rack A-12',
    zone: 'Zone A',
    status: 'healthy',
    lastMovement: '2 jam lalu',
    reservedStock: 500,
    availableStock: 700
  }, {
    id: 'WH-INV-002',
    sku: 'SKU-AQ-002',
    name: 'Aqua Galon 19L',
    category: 'Minuman',
    stock: 300,
    unit: 'Galon',
    location: 'Rack B-05',
    zone: 'Zone B',
    status: 'healthy',
    lastMovement: '4 jam lalu',
    reservedStock: 200,
    availableStock: 100
  }, {
    id: 'WH-INV-003',
    sku: 'SKU-BR-005',
    name: 'Beras Ramos 5kg',
    category: 'Sembako',
    stock: 800,
    unit: 'Karung',
    location: 'Rack C-08',
    zone: 'Zone C',
    status: 'healthy',
    lastMovement: '1 hari lalu',
    reservedStock: 400,
    availableStock: 400
  }, {
    id: 'WH-INV-004',
    sku: 'SKU-IM-002',
    name: 'Indomie Soto',
    category: 'Makanan',
    stock: 450,
    unit: 'Karton',
    location: 'Rack A-15',
    zone: 'Zone A',
    status: 'low',
    lastMovement: '3 jam lalu',
    reservedStock: 300,
    availableStock: 150
  }];
  const zones = [{
    name: 'Zone A',
    capacity: 2000,
    used: 1650,
    utilization: 82.5
  }, {
    name: 'Zone B',
    capacity: 1500,
    used: 300,
    utilization: 20
  }, {
    name: 'Zone C',
    capacity: 1500,
    used: 800,
    utilization: 53.3
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'healthy':
        return 'success';
      case 'low':
        return 'warning';
      case 'critical':
        return 'error';
      default:
        return 'neutral';
    }
  };
  return <div className="space-y-6" data-id="element-3743">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-3744">
        <div data-id="element-3745">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-3746">
            Warehouse Inventory
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-3747">
            Monitor stok dan lokasi barang di gudang
          </p>
        </div>
        <div className="flex gap-2" data-id="element-3748">
          <Button variant="outline" size="sm" icon={<RefreshCw className="w-4 h-4" data-id="element-3750" />} data-id="element-3749">
            Refresh
          </Button>
          <Button variant="primary" size="sm" icon={<Download className="w-4 h-4" data-id="element-3752" />} data-id="element-3751">
            Export Report
          </Button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-3753">
        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-3754">
          <div className="flex items-center justify-between mb-3" data-id="element-3755">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3756">
              <Package className="w-6 h-6 text-white" data-id="element-3757" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-3758">Total</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-3759">Total SKU</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-3760">4</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-3761">Active items</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-3762">
          <div className="flex items-center justify-between mb-3" data-id="element-3763">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3764">
              <CheckCircle className="w-6 h-6 text-white" data-id="element-3765" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-3766">Good</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-3767">Healthy Stock</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-3768">3</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-3769">Sufficient levels</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-3770">
          <div className="flex items-center justify-between mb-3" data-id="element-3771">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3772">
              <AlertCircle className="w-6 h-6 text-white" data-id="element-3773" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-3774">
              Alert
            </Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-3775">Low Stock</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-3776">1</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-3777">Need attention</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-cyan-50 to-cyan-100 border-cyan-200" data-id="element-3778">
          <div className="flex items-center justify-between mb-3" data-id="element-3779">
            <div className="w-12 h-12 bg-cyan-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3780">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-3781" />
            </div>
            <Badge className="bg-cyan-200 text-cyan-800 border-0" data-id="element-3782">64%</Badge>
          </div>
          <p className="text-sm text-cyan-700 mb-1" data-id="element-3783">Capacity Used</p>
          <p className="text-4xl font-bold text-cyan-900" data-id="element-3784">3,200</p>
          <p className="text-xs text-cyan-600 mt-1" data-id="element-3785">of 5,000 units</p>
        </Card>
      </div>

      {/* Zone Capacity */}
      <Card className="p-6" data-id="element-3786">
        <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3787">Zone Capacity</h3>
        <div className="grid grid-cols-3 gap-4" data-id="element-3788">
          {zones.map((zone, i) => <div key={i} className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-3789">
              <div className="flex items-center justify-between mb-3" data-id="element-3790">
                <h4 className="font-bold text-slate-900" data-id="element-3791">{zone.name}</h4>
                <Badge variant={zone.utilization > 80 ? 'warning' : 'success'} data-id="element-3792">
                  {zone.utilization.toFixed(1)}%
                </Badge>
              </div>
              <div className="mb-2" data-id="element-3793">
                <div className="flex justify-between text-xs text-slate-600 mb-1" data-id="element-3794">
                  <span data-id="element-3795">Used: {zone.used}</span>
                  <span data-id="element-3796">Capacity: {zone.capacity}</span>
                </div>
                <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-3797">
                  <div className={`h-full rounded-full ${zone.utilization > 80 ? 'bg-amber-500' : 'bg-cyan-500'}`} style={{
                width: `${zone.utilization}%`
              }} data-id="element-3798"></div>
                </div>
              </div>
            </div>)}
        </div>
      </Card>

      {/* Search */}
      <Card className="p-4" data-id="element-3799">
        <div className="relative" data-id="element-3800">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-3801" />
          <input type="text" placeholder="Cari SKU, nama produk, atau lokasi..." className="w-full pl-10 pr-4 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500" data-id="element-3802" />
        </div>
      </Card>

      {/* Inventory List */}
      <div className="space-y-4" data-id="element-3803">
        {inventory.map(item => <Card key={item.id} className="p-6" data-id="element-3804">
            <div className="flex items-start gap-6" data-id="element-3805">
              {/* Status Icon */}
              <div className="flex-shrink-0" data-id="element-3806">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center shadow-lg ${item.status === 'healthy' ? 'bg-gradient-to-br from-green-500 to-green-600' : item.status === 'low' ? 'bg-gradient-to-br from-amber-500 to-amber-600' : 'bg-gradient-to-br from-red-500 to-red-600'}`} data-id="element-3807">
                  <Package className="w-8 h-8 text-white" data-id="element-3808" />
                </div>
              </div>

              {/* Item Info */}
              <div className="flex-1 min-w-0" data-id="element-3809">
                <div className="flex items-start justify-between mb-3" data-id="element-3810">
                  <div data-id="element-3811">
                    <div className="flex items-center gap-3 mb-2" data-id="element-3812">
                      <h3 className="text-xl font-bold text-slate-900" data-id="element-3813">
                        {item.name}
                      </h3>
                      <Badge variant={getStatusColor(item.status)} data-id="element-3814">
                        {item.status === 'healthy' ? 'Healthy' : 'Low Stock'}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-3815">
                      <span data-id="element-3816">SKU: {item.sku}</span>
                      <span className="text-slate-400" data-id="element-3817">•</span>
                      <span data-id="element-3818">{item.category}</span>
                      <span className="text-slate-400" data-id="element-3819">•</span>
                      <div className="flex items-center gap-1" data-id="element-3820">
                        <MapPin className="w-4 h-4" data-id="element-3821" />
                        <span data-id="element-3822">
                          {item.location} ({item.zone})
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-3823">
                    <p className="text-sm text-slate-600 mb-1" data-id="element-3824">Total Stock</p>
                    <p className="text-3xl font-bold text-slate-900" data-id="element-3825">
                      {item.stock}
                    </p>
                    <p className="text-sm text-slate-600" data-id="element-3826">{item.unit}</p>
                  </div>
                </div>

                {/* Stock Breakdown */}
                <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-3827">
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3828">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3829">
                      Available Stock
                    </p>
                    <p className="text-lg font-bold text-green-600" data-id="element-3830">
                      {item.availableStock} {item.unit}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3831">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3832">
                      Reserved Stock
                    </p>
                    <p className="text-lg font-bold text-amber-600" data-id="element-3833">
                      {item.reservedStock} {item.unit}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-3834">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-3835">Last Movement</p>
                    <p className="text-lg font-bold text-slate-900" data-id="element-3836">
                      {item.lastMovement}
                    </p>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-3837">
                  <Button variant="outline" size="sm" data-id="element-3838">
                    View History
                  </Button>
                  <Button variant="outline" size="sm" data-id="element-3839">
                    Adjust Stock
                  </Button>
                  <Button variant="outline" size="sm" icon={<MapPin className="w-4 h-4" data-id="element-3841" />} data-id="element-3840">
                    Change Location
                  </Button>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}